// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Label = require("../common/Components/Label.bs.js");
var React = require("react");
var IconV5 = require("../../uikit/atoms/Icon/IconV5.bs.js");
var Callout = require("../common/Components/Callout.bs.js");
var Scalars = require("../../scalars/Scalars.bs.js");
var Redirect = require("../../reason/common/Redirect.bs.js");
var ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Link = require("next/link").default;
var FeaturesV3 = require("../../reason/featureFlipper/FeaturesV3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var ReactRender = require("../../reason/utils/ReactRender.bs.js");
var UserSession = require("../../reason/common/UserSession/UserSession.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var MarketingProfileSubpages = require("./MarketingProfileSubpages.bs.js");
var SwitchToAgentProfileDialog = require("./SwitchToAgentProfileDialog.bs.js");
var UnselectedUnionMemberError = require("../common/ErrorHandling/UnselectedUnionMemberError.bs.js");
var ShareTeamMarketingProfileDialog = require("./ShareTeamMarketingProfileDialog.bs.js");
var TeamMarketingProfileSettingsQuery_graphql = require("../../__generated__/TeamMarketingProfileSettingsQuery_graphql.bs.js");
var TeamMarketingProfileSettings_page_teamMarketingProfile_graphql = require("../../__generated__/TeamMarketingProfileSettings_page_teamMarketingProfile_graphql.bs.js");
var TeamMarketingProfileSettings_header_teamMarketingProfile_graphql = require("../../__generated__/TeamMarketingProfileSettings_header_teamMarketingProfile_graphql.bs.js");
var TeamMarketingProfileSettings_incompleteProfileCallout_teamMarketingProfile_graphql = require("../../__generated__/TeamMarketingProfileSettings_incompleteProfileCallout_teamMarketingProfile_graphql.bs.js");

var convertFragment = TeamMarketingProfileSettings_header_teamMarketingProfile_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, TeamMarketingProfileSettings_header_teamMarketingProfile_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(TeamMarketingProfileSettings_header_teamMarketingProfile_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, TeamMarketingProfileSettings_header_teamMarketingProfile_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(TeamMarketingProfileSettings_header_teamMarketingProfile_graphql.node, convertFragment, fRef);
}

var Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function TeamMarketingProfileSettings$Header(props) {
  var marketingProfile = use(props.marketingProfile);
  var match = React.useState(function () {
        return false;
      });
  var setShareModalShown = match[1];
  return JsxRuntime.jsxs("header", {
              children: [
                JsxRuntime.jsx(ShareTeamMarketingProfileDialog.make, {
                      marketingProfile: marketingProfile.fragmentRefs,
                      isOpen: match[0],
                      onDismiss: (function () {
                          setShareModalShown(function (param) {
                                return false;
                              });
                        })
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("h2", {
                                      children: "Marketing Profile",
                                      className: "text-zinc-800 text-3xl font-medium leading-6"
                                    }),
                                JsxRuntime.jsx(Label.Neutral.make, {
                                      text: "Team Profile"
                                    })
                              ],
                              className: "flex items-center gap-3 justify-between lg:justify-normal "
                            }),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx("p", {
                                    children: "The Marketing Profile is a public page that others can search for or that you can share to promote and showcase the value of your TAN membership.\n"
                                  }),
                              className: "space-y-1 text-base max-w-2xl text-zinc-500"
                            })
                      ],
                      className: "space-y-4"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                              onClick: (function (param) {
                                  setShareModalShown(function (param) {
                                        return true;
                                      });
                                }),
                              className: "",
                              children: "Share Profile"
                            }),
                        JsxRuntime.jsx(ButtonsV5.PrimaryButton.make, {
                              href: Scalars.$$URL.toString(marketingProfile.publicUrl),
                              target: "_blank",
                              children: "View Profile"
                            })
                      ],
                      className: "flex flex-row gap-4"
                    })
              ],
              className: "flex justify-between flex-col lg:flex-row lg:items-end gap-8 border-b pb-6"
            });
}

var Header = {
  Fragment: Fragment,
  make: TeamMarketingProfileSettings$Header
};

function TeamMarketingProfileSettings$PlanCallout(props) {
  return JsxRuntime.jsx(Callout.Warning.make, {
              children: Caml_option.some(JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("div", {
                                children: "Upgrade to PRO to make your profile look even better."
                              }),
                          JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(ButtonsV5.OutlineButton.make, {
                                      href: "/plans",
                                      size: "small",
                                      children: "Upgrade to PRO",
                                      color: "TanBlue"
                                    })
                              })
                        ],
                        className: "flex flex-col gap-4"
                      })),
              title: "You currently have a limited version of the marketing profile"
            });
}

var PlanCallout = {
  make: TeamMarketingProfileSettings$PlanCallout
};

var convertFragment$1 = TeamMarketingProfileSettings_incompleteProfileCallout_teamMarketingProfile_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, TeamMarketingProfileSettings_incompleteProfileCallout_teamMarketingProfile_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(TeamMarketingProfileSettings_incompleteProfileCallout_teamMarketingProfile_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, TeamMarketingProfileSettings_incompleteProfileCallout_teamMarketingProfile_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(TeamMarketingProfileSettings_incompleteProfileCallout_teamMarketingProfile_graphql.node, convertFragment$1, fRef);
}

var Fragment$1 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function TeamMarketingProfileSettings$IncompleteProfileCallout$ActionLink(props) {
  return JsxRuntime.jsx("li", {
              children: JsxRuntime.jsx(ButtonsV5.Link.make, {
                    href: props.url,
                    children: Caml_option.some(JsxRuntime.jsx("span", {
                              children: props.text,
                              className: "underline"
                            }))
                  })
            });
}

var ActionLink = {
  make: TeamMarketingProfileSettings$IncompleteProfileCallout$ActionLink
};

function TeamMarketingProfileSettings$IncompleteProfileCallout(props) {
  var marketingProfile = use$1(props.marketingProfile);
  var teamPhoto = marketingProfile.teamPhoto;
  var members = marketingProfile.members;
  var logo = marketingProfile.logo;
  var about = marketingProfile.about;
  var shouldRender = teamPhoto !== undefined && logo !== undefined && about !== undefined && members !== undefined ? members.totalCount <= 0 : true;
  return ReactRender.ifTrue(JsxRuntime.jsx(Callout.Info.make, {
                  children: Caml_option.some(JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    children: "Your marketing profile is active but appears to be lacking some content. Follow these steps to improve it:"
                                  }),
                              JsxRuntime.jsxs("ul", {
                                    children: [
                                      teamPhoto !== undefined ? (
                                          logo !== undefined ? null : JsxRuntime.jsx(TeamMarketingProfileSettings$IncompleteProfileCallout$ActionLink, {
                                                  text: "Add your team's logo",
                                                  url: "/account/team_marketing_profile/photos"
                                                })
                                        ) : (
                                          logo !== undefined ? JsxRuntime.jsx(TeamMarketingProfileSettings$IncompleteProfileCallout$ActionLink, {
                                                  text: "Add your team's group photo",
                                                  url: "/account/team_marketing_profile/photos"
                                                }) : JsxRuntime.jsx(TeamMarketingProfileSettings$IncompleteProfileCallout$ActionLink, {
                                                  text: "Add your team's logo and group photo",
                                                  url: "/account/team_marketing_profile/photos"
                                                })
                                        ),
                                      about !== undefined ? null : JsxRuntime.jsx(TeamMarketingProfileSettings$IncompleteProfileCallout$ActionLink, {
                                              text: "Update the \"about\" section for your team",
                                              url: "/account/team_marketing_profile/about"
                                            }),
                                      members !== undefined && members.totalCount === 0 ? JsxRuntime.jsx(TeamMarketingProfileSettings$IncompleteProfileCallout$ActionLink, {
                                              text: "Add your team's members",
                                              url: "/account/team_marketing_profile/members"
                                            }) : null
                                    ],
                                    className: "list-disc list-inside flex flex-col gap-2"
                                  })
                            ],
                            className: "flex flex-col gap-3"
                          })),
                  title: "Complete your marketing profile"
                }), shouldRender);
}

var IncompleteProfileCallout = {
  Fragment: Fragment$1,
  ActionLink: ActionLink,
  make: TeamMarketingProfileSettings$IncompleteProfileCallout
};

function TeamMarketingProfileSettings$SettingsLinks$Setting(props) {
  return JsxRuntime.jsxs(Link, {
              href: props.url,
              className: "border rounded-lg p-4 flex justify-between items-center",
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: props.name,
                              className: "text-zinc-800 text-base font-semibold"
                            }),
                        JsxRuntime.jsx("div", {
                              children: props.description,
                              className: "text-zinc-600"
                            })
                      ],
                      className: "space-y-3"
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(IconV5.make, {
                            icon: "arrow-right",
                            className: "h-4 w-4 text-zinc-600"
                          })
                    })
              ]
            });
}

var Setting = {
  make: TeamMarketingProfileSettings$SettingsLinks$Setting
};

function descriptionOfPage(page) {
  switch (page) {
    case "BasicInfo" :
        return "Update your team name, brokerage, and website";
    case "Photos" :
        return "Update your team's logo and group photo";
    case "About" :
        return "Update your team's about section";
    case "SocialMedia" :
        return "Link to your team's social media accounts";
    case "Members" :
        return "Update your team's members";
    case "Url" :
        return "Personalize the URL for your profile.";
    
  }
}

function TeamMarketingProfileSettings$SettingsLinks(props) {
  var subpages = MarketingProfileSubpages.useTeamProfilePages(undefined, undefined);
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("h3", {
                              children: "Update your profile",
                              className: "text-zinc-800 text-2xl font-medium leading-6"
                            }),
                        JsxRuntime.jsx("p", {
                              children: "Note that updating your Marketing Profile does not affect how you appear to other agents and clients on TAN. Your TAN Profile is what determines how you appear to others on the platform.",
                              className: "text-base text-zinc-500"
                            })
                      ],
                      className: "space-y-2"
                    }),
                JsxRuntime.jsx("div", {
                      children: subpages.map(function (page) {
                            return JsxRuntime.jsx(TeamMarketingProfileSettings$SettingsLinks$Setting, {
                                        name: page.displayName,
                                        description: descriptionOfPage(page.page),
                                        url: page.path
                                      });
                          }),
                      className: "space-y-6"
                    })
              ],
              className: "space-y-6"
            });
}

var SettingsLinks = {
  Setting: Setting,
  descriptionOfPage: descriptionOfPage,
  make: TeamMarketingProfileSettings$SettingsLinks
};

function TeamMarketingProfileSettings$ChangeProfileTypeSection(props) {
  var match = React.useState(function () {
        return false;
      });
  var setIsDialogOpen = match[1];
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(SwitchToAgentProfileDialog.make, {
                      isOpen: match[0],
                      onDismiss: (function () {
                          setIsDialogOpen(function (param) {
                                return false;
                              });
                        })
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("h3", {
                              children: "Switch to an agent profile",
                              className: "text-zinc-800 text-xl font-medium leading-6"
                            }),
                        JsxRuntime.jsx("p", {
                              children: "Your current marketing profile is designed for a team. If you wish to switch back to a single agent profile, click the button below.",
                              className: "text-base text-zinc-500 "
                            })
                      ],
                      className: "space-y-4"
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(ButtonsV5.SecondaryButton.make, {
                            onClick: (function (param) {
                                setIsDialogOpen(function (param) {
                                      return true;
                                    });
                              }),
                            size: "small",
                            children: "Switch to agent profile"
                          }),
                      className: "space-y-4"
                    })
              ],
              className: "space-y-4 border-t border-zinc-200 pt-6"
            });
}

var ChangeProfileTypeSection = {
  make: TeamMarketingProfileSettings$ChangeProfileTypeSection
};

var convertFragment$2 = TeamMarketingProfileSettings_page_teamMarketingProfile_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, TeamMarketingProfileSettings_page_teamMarketingProfile_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(TeamMarketingProfileSettings_page_teamMarketingProfile_graphql.node, convertFragment$2, fRef);
}

function useOpt$2(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, TeamMarketingProfileSettings_page_teamMarketingProfile_graphql.node, convertFragment$2);
}

function readResolverFragment$2(fRef) {
  return RescriptRelay_Fragment.read(TeamMarketingProfileSettings_page_teamMarketingProfile_graphql.node, convertFragment$2, fRef);
}

var Fragment$2 = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$2,
  readResolverFragment: readResolverFragment$2
};

function TeamMarketingProfileSettings$Page(props) {
  var marketingProfile = use$2(props.marketingProfile);
  var hasFullProfile = UserSession.useHasPlanFeature("FULL_AGENT_PAGE");
  var switchToAgentProfileEnabled = FeaturesV3.useFeatureFlipper("SwitchTeamToAgentMarketingProfile") === "on";
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx(TeamMarketingProfileSettings$Header, {
                            marketingProfile: marketingProfile.fragmentRefs
                          }),
                      (function (__x) {
                            return ReactRender.ifFalse(JsxRuntime.jsx(TeamMarketingProfileSettings$PlanCallout, {}), __x);
                          })(hasFullProfile),
                      (function (__x) {
                            return ReactRender.ifTrue(JsxRuntime.jsx(TeamMarketingProfileSettings$IncompleteProfileCallout, {
                                            marketingProfile: marketingProfile.fragmentRefs
                                          }), __x);
                          })(hasFullProfile),
                      JsxRuntime.jsx(TeamMarketingProfileSettings$SettingsLinks, {}),
                      (function (__x) {
                            return ReactRender.ifTrue(JsxRuntime.jsx(TeamMarketingProfileSettings$ChangeProfileTypeSection, {}), __x);
                          })(switchToAgentProfileEnabled)
                    ],
                    className: "space-y-6"
                  }),
              className: "bg-white p-6 shadow-sm rounded space-y-8"
            });
}

var Page = {
  Fragment: Fragment$2,
  make: TeamMarketingProfileSettings$Page
};

var convertVariables = TeamMarketingProfileSettingsQuery_graphql.Internal.convertVariables;

var convertResponse = TeamMarketingProfileSettingsQuery_graphql.Internal.convertResponse;

var convertWrapRawResponse = TeamMarketingProfileSettingsQuery_graphql.Internal.convertWrapRawResponse;

var use$3 = RescriptRelay_Query.useQuery(convertVariables, TeamMarketingProfileSettingsQuery_graphql.node, convertResponse);

var useLoader = RescriptRelay_Query.useLoader(convertVariables, TeamMarketingProfileSettingsQuery_graphql.node, (function (prim) {
        return prim;
      }));

var usePreloaded = RescriptRelay_Query.usePreloaded(TeamMarketingProfileSettingsQuery_graphql.node, convertResponse, (function (prim) {
        return prim;
      }));

var $$fetch = RescriptRelay_Query.$$fetch(TeamMarketingProfileSettingsQuery_graphql.node, convertResponse, convertVariables);

var fetchPromised = RescriptRelay_Query.fetchPromised(TeamMarketingProfileSettingsQuery_graphql.node, convertResponse, convertVariables);

var retain = RescriptRelay_Query.retain(TeamMarketingProfileSettingsQuery_graphql.node, convertVariables);

var Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use$3,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  $$fetch: $$fetch,
  fetchPromised: fetchPromised,
  retain: retain
};

function TeamMarketingProfileSettings(props) {
  var match = use$3(undefined, undefined, undefined, undefined);
  var marketingProfile = match.currentAccountV5.marketingProfile;
  switch (marketingProfile.__typename) {
    case "AgentMarketingProfile" :
        return JsxRuntime.jsx(Redirect.make, {
                    path: "/account/marketing_profile"
                  });
    case "TeamMarketingProfile" :
        return JsxRuntime.jsx(TeamMarketingProfileSettings$Page, {
                    marketingProfile: marketingProfile.fragmentRefs
                  });
    case "__unselected" :
        return UnselectedUnionMemberError.raise("Unselected union member: " + marketingProfile._0);
    
  }
}

var make = TeamMarketingProfileSettings;

exports.Header = Header;
exports.PlanCallout = PlanCallout;
exports.IncompleteProfileCallout = IncompleteProfileCallout;
exports.SettingsLinks = SettingsLinks;
exports.ChangeProfileTypeSection = ChangeProfileTypeSection;
exports.Page = Page;
exports.Query = Query;
exports.make = make;
/* use Not a pure module */
